import React from 'react';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Alarm from '@material-ui/icons/Alarm';
import Email from '@material-ui/icons/Email';
import Send from '@material-ui/icons/Send';
import Code from '@material-ui/icons/Code';
import Link from '@material-ui/icons/Link';
import LocalMovies from '@material-ui/icons/LocalMovies';
import FileCopy from '@material-ui/icons/FileCopy';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Slider from '@material-ui/lab/Slider';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';


const styles = {
  divider: {
    paddingTop: 20,
    paddingBottom: 20
  }
}

export default class Embed extends React.Component {

  constructor(props) {
    super(props);
    
    let link = (window.isVod) ? document.location.href.replace('manager', 'vod') : document.location.href.replace('manager', 'live');
    
    this.state = {
      value: 50,
      width: 640,
      odj: true,
      responsive: false,
      justAudio: false,
      iframeCopied: 'Cliquer sur le champ pour copier le texte',
      link: link,
    }
    this.iframeTpl = '<iframe width="%w" height="%h" src="' + link + '%p"></iframe>';
    this.iframeResponsiveTpl = '<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="' + link + '%p" frameborder="0" scrolling="no" allowFullScreen="true" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
  }
  sliderChange = (event, value) => {
    let v = Math.round(value * 9 + 200);

    this.setState({
      value: value,
      width: v
    })
  }

  handleCheckODJ = (e) => {
    this.setState({
      odj: e.target.checked
    });
  }
  handleCheckResponsive = (e) => {
    this.setState({
      responsive: e.target.checked
    });
  }
  
  copyIframe2 = () => {
    document.getElementById('iframe_input').select();
    try {
      var successful = document.execCommand('copy');
      this.setState({
        iframeCopied: 'Copié dans le presse papier'
      })
    }
    catch (err) {
      console.log('copy fail')
    }
  }
  
  copyIframe = () => {
    this.copy(document.getElementById('iframe_input'));
    this.setState({
      iframeCopied: 'Copié dans le presse papier'
    })
  }
  
  copy(el) {
    var oldContentEditable = el.contentEditable,
      oldReadOnly = el.readOnly,
      range = document.createRange();

    el.contentEditable = true;
    el.readOnly = false;
    range.selectNodeContents(el);

    var s = window.getSelection();
    s.removeAllRanges();
    s.addRange(range);

    el.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

    el.contentEditable = oldContentEditable;
    el.readOnly = oldReadOnly;

    document.execCommand('copy');
  }
  
  copyLink2 = () => {
    document.getElementById('link_input').select();
    try {
      var successful = document.execCommand('copy');
      this.setState({
        linkCopied: 'Copié dans le presse papier'
      })
    }
    catch (err) {
      console.log('copy fail')
    }
  }
  
  render() {
    const { value } = this.state;

    if (!this.state.odj)
      this.params = '?odj=hide';
    else
      this.params = '';

    //console.log(this.params);

    if (this.iframeTpl) {
      if (this.state.responsive)
        this.iframe = this.iframeResponsiveTpl;
      else
        this.iframe = this.iframeTpl;

      this.iframe = this.iframe.replace('/manager/', '/vod/');
      this.iframe = this.iframe.replace('%w', this.state.width);
      this.iframe = this.iframe.replace('%h', Math.round(this.state.width * (3 / 4)));
      this.iframe = this.iframe.replace('%p', this.params);
    }

    return (
      <Grid  container direction="row" style={{ alignItems: 'center' }} className={ 'extract' }>
        <Grid item xs={12} className={'align-left'}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.odj}
                  onChange={this.handleCheckODJ}
                  color="primary"
                />
              }
              label="Avec ordre du jour"
            />
        </Grid>
        
        <Grid item xs={5} className={'align-left'}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.responsive}
                  onChange={this.handleCheckResponsive}
                  color="primary"
                />
              }
              label="Responsive"
            />
        </Grid>
        {! this.state.responsive &&
        <Grid item xs={5} className={'align-right'} style={{ overflowX:'hidden', paddingBottom: '24px', paddingTop: '14px' }}>
          <Typography>{ this.state.width } px de large</Typography>
          <Slider
            value={value}
            aria-labelledby="label"
            
            onChange={ this.sliderChange }
          />
        </Grid> }
        
        <Grid item xs={1} className={'center'}>
         
        </Grid>
        <Grid item xs={12} className={'center'} style={ styles.divider }>
          <Divider />
        </Grid>
        <Grid item xs={1} className={'center'}>
          <Code color="secondary" />
        </Grid>
        
        <Grid item xs={10} className={'center'}>
          
          <TextField
            id="standard-full-width"
            label="Intégrer l'extrait vidéo sur votre site"
            style={{ margin: 8 }}
            value={ this.iframe }
            helperText={ this.state.iframeCopied }
            onClick={ this.copyIframe }
            id="iframe_input"
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            
          />
        
        </Grid>
        
        <Grid item xs={1} className={'center'}>
          <IconButton color="primary" onClick={ this.copyIframe2 }>
            <FileCopy />
          </IconButton>
        </Grid>
        
        <Grid item xs={1} className={'center'}>
          <Link color="secondary" />
        </Grid>
      
        <Grid item xs={10} className={'center'}>
          <TextField
            id="standard-full-width"
            label="Partager le lien cet extrait vidéo"
            style={{ margin: 8 }}
            value={ this.state.link + this.params}
            helperText={ this.state.linkCopied }
            onClick={ this.copyLink }
            id="link_input"
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        
        <Grid item xs={1} className={'center'}>
          <IconButton color="primary" onClick={ this.copyLink2 }>
            <FileCopy />
          </IconButton>
        </Grid>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Manager/Embed.js